<template>
  <div :id="uid" class="zt-expansion-panel w-full rounded border border-zt-gray" :class="activeClassPanel">
    <div
      class="selected-disabled zt-expansion-panel--header cursor-pointer w-full flex items-center justify-between p-custom"
      :class="classes"
      @click="_onClick"
    >
      <h2 class="text-zt-lg">
        <zt-icon :name="prependIcon" v-if="prependIcon !== ''" class="mr-4 text-zt-xl" />
        <span>{{ title }}</span>
      </h2>
      <zt-icon :name="iconName" class="text-zt-xl bold" />
    </div>
    <transition
      name="accordion"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end"
    >
      <div
        v-show="isActiveContent"
        class="zt-expansion-panel--content w-full"
      >
        <div class="p-4">
          <slot />
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { forEach } from "lodash";
export default {
  name: "ExpansionPanel",
  inject:{
    wrapperPanels: {
      type: Object,
      required: true
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'caret-down'
    },
    iconActive: {
      type: String,
      default: 'caret-up'
    },
    prependIcon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: true
    },
    autoCollapse: {
      type: Boolean,
      default: true
    },
    focusActive: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    isActiveContent: {
      handler(value) {
        this.$emit('open', value)
      },
      immediate: true
    }
  },
  computed: {
    iconName() {
      return this.isActiveContent ? this.iconActive : this.icon
    },
    classes() {
      if (this.disabled) {
        return 'opacity-disabled'
      }
      if (this.isActiveContent) {
        return 'bg-zt-dark-custom border-b border-zt-gray'
      }
      return ''
    },
    activeClassPanel() {
      return {
        'panel-is-active': this.isActiveContent
      }
    }
  },
  data() {
    return {
      isActiveContent: false,
      uid: ''
    }
  },
  methods: {
    _onClick() {
      if (this.disabled) return
      this.isActiveContent = !this.isActiveContent
      this.$emit('handleClick', this)
      if(this.autoCollapse) {
        const children = this.wrapperPanels._data.children
        forEach(children, child => {
          if(child._data.uid !== this.uid && child._props.autoCollapse) {
            child._data.isActiveContent = false
          }
        })
      }
    },
    close() {
      this.isActiveContent = false
    },
    start(el) {
      el.style.height = `${el.scrollHeight}px`;
    },
    end(el) {
      el.style.height = '';
    }
  },
  mounted() {
    this.uid = this._uid
  },
  created() {
    this.wrapperPanels.$emit('create-children', this)
  }
}
</script>

<style scoped lang="scss">
.selected-disabled {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.opacity-disabled {
  opacity: .65
}
.border-zt-gray {
  border-color: #C1BFC0!important;
}
.bg-zt-dark-custom {
  background: #EAEAEA;
}
.p-custom {
  padding: 1.25rem;
}
.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}
.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}
</style>
